/* eslint-disable */
import React from 'react';
import { useHistory } from 'react-router-dom';
import './DomainTile.css';

const DomainTile = ({ title = "Title", showBackButton = false, mainPagePath, detailState = {} }) => {
  const history = useHistory();

  const handleBackClick = () => {
    // history.goBack();
    if (mainPagePath) {
      history.push(mainPagePath, detailState);
    } else {
      history.goBack();
    }
  };

  return (
    <div className="domain-tile">
      <div className="domain-tile-header">{title}</div>
      {showBackButton && (
        <button className="back-button" onClick={handleBackClick}>
          ← Back
        </button>
      )}
    </div>
  );
};

export default DomainTile;

